import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './push-ispan.component.scss';
import { AnalyticsService } from '../../services/analytics.service';
import "bootstrap-datepicker";
var PushIspan = /** @class */ (function (_super) {
    tslib_1.__extends(PushIspan, _super);
    function PushIspan(element) {
        var _this = _super.call(this, element) || this;
        _this.isAttendingYes = false;
        _this.isFlowInitiated = false;
        return _this;
    }
    PushIspan.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js_submit-button"));
        if (this.applyForm) {
            this.displayLoader = this.applyForm.querySelector(".form-container__loader");
            this.displayFields = this.applyForm.querySelector(".form-container__fields");
            this.displaySuccess = this.applyForm.querySelector(".form-container__success");
            this.displayFail = this.applyForm.querySelector(".form-container__error");
            this.displayThankYou = this.applyForm.querySelector(".form-container__thank-you");
            this.displayResponseSuccess = this.applyForm.querySelector(".form-container__response-success");
        }
        this.containerModal = this.element.closest('.push-ispan');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.backButtons = this.containerModal.querySelectorAll('.js_back-button');
        this.initFieldLengths();
        // Initialize conditional flow properties
        this.attendingYesRadio = this.element.querySelector('.js-attending-yes');
        this.attendingNoRadio = this.element.querySelector('.js-attending-no');
        this.registrationFieldsContainer = this.element.querySelector('.js-registration-fields');
        this.notifiedSection = this.element.querySelector('.js-notified-section');
        this.privacyMarketingSection = this.element.querySelector('.js-registration-privacy-marketing');
        this.noFlowSection = this.element.querySelector('.js-no-flow-section');
        this.consentFooter = this.element.querySelector('.js-consent-footer');
        this.notifiedYesRadio = this.element.querySelector('.js-notified-yes');
        this.notifiedNoRadio = this.element.querySelector('.js-notified-no');
        this.submitButtonsContainer = this.element.querySelector('.js-submit-buttons');
        this.isAttendingYes = false;
        this.isFlowInitiated = false;
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea = this.element.querySelector(".data-sharing-sms");
        this.doneSubmit = this.element.querySelectorAll(".js_done-button");
        this.selectBankYesRadio = this.element.querySelector('input[name="select-bank"][value="Yes"]');
        this.selectBankNoRadio = this.element.querySelector('input[name="select-bank"][value="No"]');
        this.otherBankSection = this.element.querySelector('.js-other-bank-section');
        this.otherBankInput = this.element.querySelector('input[name="other-bank"]');
        if ((typeof dataLayer != 'undefined')) {
            dataLayer.application.applicationName = "Push'ispan";
        }
    };
    PushIspan.prototype.bindEvents = function () {
        var _this = this;
        if (this.attendingYesRadio) {
            this.attendingYesRadio.addEventListener('change', function () {
                if (_this.attendingYesRadio.checked) {
                    _this.isAttendingYes = true;
                    _this.isFlowInitiated = true;
                    _this.showYesFlow();
                }
            });
        }
        if (this.attendingNoRadio) {
            this.attendingNoRadio.addEventListener('change', function () {
                if (_this.attendingNoRadio.checked) {
                    _this.isAttendingYes = false;
                    _this.isFlowInitiated = true;
                    _this.notifiedSection.classList.remove('hidden');
                    _this.registrationFieldsContainer.classList.add('hidden');
                    _this.privacyMarketingSection.classList.add('hidden');
                    _this.noFlowSection.classList.add('hidden');
                    _this.submitButtonsContainer.classList.add('hidden');
                    if (_this.consentFooter) {
                        _this.consentFooter.classList.add('hidden');
                    }
                    _this.clearRegistrationFields();
                    // Reset notified radios so user has to re-select if they switch flows
                    if (_this.notifiedYesRadio)
                        _this.notifiedYesRadio.checked = false;
                    if (_this.notifiedNoRadio)
                        _this.notifiedNoRadio.checked = false;
                }
            });
        }
        if (this.notifiedYesRadio) {
            this.notifiedYesRadio.addEventListener('change', function () {
                if (_this.notifiedYesRadio.checked) {
                    _this.showNoFlow();
                }
            });
        }
        if (this.notifiedNoRadio) {
            this.notifiedNoRadio.addEventListener('change', function () {
                if (_this.notifiedNoRadio.checked) {
                    _this.showDisplayView('thank-you');
                }
            });
        }
        if (this.selectBankYesRadio) {
            this.selectBankYesRadio.addEventListener('change', function () {
                if (_this.selectBankYesRadio.checked) {
                    if (_this.otherBankSection)
                        _this.otherBankSection.classList.add('hidden');
                    if (_this.otherBankInput) {
                        _this.otherBankInput.value = '';
                        _this.otherBankInput.classList.remove('form__input--error');
                        var group = _this.otherBankInput.closest('.form__group');
                        if (group)
                            group.classList.remove('form__group--error');
                    }
                }
            });
        }
        if (this.selectBankNoRadio) {
            this.selectBankNoRadio.addEventListener('change', function () {
                if (_this.selectBankNoRadio.checked) {
                    if (_this.otherBankSection)
                        _this.otherBankSection.classList.remove('hidden');
                }
            });
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = Array.from(_form.querySelectorAll("input, select")).filter(function (el) { return !el.closest('.hidden'); });
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error")).filter(function (el) { return !el.closest('.hidden'); });
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        if (this.backButtons && this.backButtons.length > 0) {
            this.backButtons[0].addEventListener('click', function (event) { return _this.closeForm(); });
            if (this.backButtons.length > 1) {
                this.backButtons[1].addEventListener('click', function (event) { return _this.goToStep1(); });
            }
        }
        if (this.doneSubmit) {
            this.doneSubmit.forEach(function (btn) { return btn.addEventListener('click', function (event) { return _this.closeForm(); }); });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    PushIspan.prototype.showYesFlow = function () {
        // Show registration fields and privacy/marketing for attendees
        this.registrationFieldsContainer.classList.remove('hidden');
        this.privacyMarketingSection.classList.remove('hidden');
        this.notifiedSection.classList.add('hidden');
        this.noFlowSection.classList.add('hidden');
        this.submitButtonsContainer.classList.remove('hidden');
        if (this.consentFooter) {
            this.consentFooter.classList.remove('hidden');
        }
        // Clear and reset not-attending fields
        var noFlowFirstName = this.applyForm.querySelector('input[name=firstNameNoFlow]');
        var noFlowEmail = this.applyForm.querySelector('input[name=emailAddressNoFlow]');
        if (noFlowFirstName) {
            noFlowFirstName.value = '';
            noFlowFirstName.classList.remove('form__input--error');
        }
        if (noFlowEmail) {
            noFlowEmail.value = '';
            noFlowEmail.classList.remove('form__input--error');
        }
        // Reset notified radios
        if (this.notifiedYesRadio)
            this.notifiedYesRadio.checked = false;
        if (this.notifiedNoRadio)
            this.notifiedNoRadio.checked = false;
        // Reset select-bank flow
        if (this.otherBankSection) {
            this.otherBankSection.classList.add('hidden');
        }
        window.scroll({ top: 0, behavior: "smooth" });
    };
    PushIspan.prototype.showNoFlow = function () {
        // Show only notification preference and name/email for non-attendees
        this.registrationFieldsContainer.classList.add('hidden');
        this.privacyMarketingSection.classList.remove('hidden');
        this.notifiedSection.classList.remove('hidden');
        this.noFlowSection.classList.remove('hidden');
        this.submitButtonsContainer.classList.remove('hidden');
        if (this.consentFooter) {
            this.consentFooter.classList.remove('hidden');
        }
        // Clear registration fields
        this.clearRegistrationFields();
        window.scroll({ top: 0, behavior: "smooth" });
    };
    PushIspan.prototype.clearRegistrationFields = function () {
        var _this = this;
        // Clear all registration fields when switching to No flow
        var fieldsToReset = [
            'firstName', 'surname', 'business-name', 'emailAddress',
            'contactNum', 'select-province', 'select-bank', 'other-bank'
        ];
        fieldsToReset.forEach(function (fieldName) {
            var field = _this.applyForm.querySelector("input[name=\"" + fieldName + "\"], select[name=\"" + fieldName + "\"]");
            if (field) {
                field.value = '';
                field.classList.remove('form__input--error');
            }
        });
        // Clear checkboxes and radios except attending and notified
        var checkboxesRadios = this.applyForm.querySelectorAll('input[type="checkbox"], input[type="radio"]');
        checkboxesRadios.forEach(function (input) {
            var inputName = input.name;
            if (inputName !== 'attending' && inputName !== 'notified') {
                input.checked = false;
            }
        });
    };
    PushIspan.prototype.initFieldLengths = function () {
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        _firstName.setAttribute("maxlength", "80");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        _surname.setAttribute("maxlength", "80");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNum]");
        _contactNumber.setAttribute("maxlength", "10");
        var _contactNumberNoFlow = this.applyForm.querySelector("input[name=contactNumNoFlow]");
        _contactNumberNoFlow.setAttribute("maxlength", "10");
    };
    PushIspan.prototype.validSAContact = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^0[0-9]\d{8}$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    PushIspan.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.remove("active");
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displayFail.classList.remove("active");
        this.displayFail.classList.add("hidden");
        if (this.displayThankYou) {
            this.displayThankYou.classList.remove("active");
            this.displayThankYou.classList.add("hidden");
        }
        if (this.displayResponseSuccess) {
            this.displayResponseSuccess.classList.remove("active");
            this.displayResponseSuccess.classList.add("hidden");
        }
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.add("active");
                this.displayFields.classList.remove("hidden");
                break;
            case "thank-you":
                if (this.displayThankYou) {
                    this.displayThankYou.classList.add("active");
                    this.displayThankYou.classList.remove("hidden");
                }
                break;
            case "response-success":
                if (this.displayResponseSuccess) {
                    this.displayResponseSuccess.classList.add("active");
                    this.displayResponseSuccess.classList.remove("hidden");
                }
                break;
            case "success":
                this.displaySuccess.classList.add("active");
                this.displaySuccess.classList.remove("hidden");
                break;
            case "fail":
                this.displayFail.classList.add("active");
                this.displayFail.classList.remove("hidden");
                break;
            default:
                this.displayLoader.classList.add("active");
                this.displayLoader.classList.remove("hidden");
                break;
        }
    };
    PushIspan.prototype.closeForm = function () {
        var baseUrl = this.element.querySelector('input[name=productPage]');
        window.location.href = baseUrl.value || '/southafrica/business';
    };
    PushIspan.prototype.goToStep1 = function () {
        this.registrationFieldsContainer.classList.add('hidden');
        this.privacyMarketingSection.classList.add('hidden');
        this.noFlowSection.classList.add('hidden');
        this.submitButtonsContainer.classList.add('hidden');
        if (this.consentFooter) {
            this.consentFooter.classList.add('hidden');
        }
        if (this.attendingNoRadio && this.attendingNoRadio.checked) {
            this.notifiedSection.classList.remove('hidden');
        }
        else {
            this.notifiedSection.classList.add('hidden');
        }
        this.isFlowInitiated = false;
        window.scroll({ top: 0, behavior: "smooth" });
    };
    PushIspan.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            this.registrationFieldsContainer.classList.add('hidden');
            this.privacyMarketingSection.classList.add('hidden');
            this.notifiedSection.classList.add('hidden');
            this.noFlowSection.classList.add('hidden');
            this.submitButtonsContainer.classList.add('hidden');
            if (this.consentFooter) {
                this.consentFooter.classList.add('hidden');
            }
            this.isAttendingYes = false;
            this.isFlowInitiated = false;
            this.showDisplayView("fields");
        }
    };
    PushIspan.prototype.submitForm = function (form) {
        var _this = this;
        var _displayName = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var analyticsService = new AnalyticsService();
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        var _email = this.applyForm.querySelector("input[name=emailAddress]");
        var _notifiedRadio = this.element.querySelector('input[name="notified"]:checked');
        var errors = [];
        // Handle No Flow - Minimal Submission
        if (!this.isAttendingYes) {
            var _firstNameNo = this.applyForm.querySelector("input[name=firstNameNoFlow]");
            var _emailNo = this.applyForm.querySelector("input[name=emailAddressNoFlow]");
            var _contactNumNo = this.applyForm.querySelector("input[name=contactNumNoFlow]");
            // Validate required fields for No flow
            if (!_firstNameNo || !_firstNameNo.value.trim()) {
                errors.push('First name is required');
            }
            if (!_emailNo || !_emailNo.value.trim()) {
                errors.push('Email address is required');
            }
            if (!_contactNumNo || !_contactNumNo.value.trim()) {
                errors.push('Contact number is required');
            }
            if (errors.length !== 0) {
                this.showDisplayView('fields');
                analyticsService.dtmFormComplete("complete", "false");
                if (_firstNameNo && errors.some(function (e) { return e.includes('First name'); })) {
                    this.validationService.addErrorMessage(_firstNameNo, [errors.find(function (e) { return e.includes('First name'); })]);
                }
                if (_emailNo && errors.some(function (e) { return e.includes('Email'); })) {
                    this.validationService.addErrorMessage(_emailNo, [errors.find(function (e) { return e.includes('Email'); })]);
                }
                if (_contactNumNo && errors.some(function (e) { return e.includes('Contact number'); })) {
                    this.validationService.addErrorMessage(_contactNumNo, [errors.find(function (e) { return e.includes('Contact number'); })]);
                }
                window.scroll({ top: 0, behavior: "smooth" });
                return;
            }
            var _popiConsent_1 = this.applyForm.querySelector("input[name=popia-consent]");
            var _recipientHidden = this.applyForm.querySelector("input[name=recipient]");
            var _mailBoxEmailHidden = this.applyForm.querySelector("input[name=email]");
            var _postData_1 = {
                subject: "Push'ispan",
                product: "Push'ispan",
                firstName: (_firstNameNo ? _firstNameNo.value : ""),
                email: (_recipientHidden ? _recipientHidden.value : ""),
                contactNo: (_contactNumNo ? _contactNumNo.value : ""),
                recipient: (_mailBoxEmailHidden ? _mailBoxEmailHidden.value : ""),
                emailAddress: (_emailNo ? _emailNo.value : ""),
                attending: "No",
                notified: (_notifiedRadio ? _notifiedRadio.value : ""),
                dataPrivacyConsent: ((_popiConsent_1 && _popiConsent_1.checked) ? "YES" : "NO"),
                dataSharingGroup: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-group'),
                dataSharing3rdParty: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-3rd-party'),
                dataSharingBoarders: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-boarders'),
                dataSharingTelesale: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-telesale'),
                dataSharingEmail: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-email'),
                dataSharingSms: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-sms'),
            };
            this.showDisplayView("loader");
            var url_1 = this.baseUrl + "/bcleadUtils/push-ispan";
            var _config_1 = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            this.formsService.postForm(url_1, _postData_1, _config_1).then(function (response) {
                var _response = response.data;
                if (_response.toString().includes('invalid')) {
                    analyticsService.dtmFormComplete("complete", "false");
                    _this.showDisplayView("fail");
                }
                else {
                    if (_displayName) {
                        _displayName.map(function (pElement) {
                            pElement.innerHTML = _postData_1.firstName;
                        });
                    }
                    analyticsService.dtmFormComplete("complete", "true");
                    _this.showDisplayView("response-success");
                    window.scroll({ top: 0, behavior: "smooth" });
                }
            }).catch(function (response) {
                analyticsService.dtmFormComplete("complete", "false");
                this.showDisplayView("fail");
            });
            return;
        }
        // Handle Yes Flow - Full Registration
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNum]");
        var _recipient = this.applyForm.querySelector("input[name=recipient]");
        var _mailBoxEmail = this.applyForm.querySelector("input[name=email]");
        var _businessName = this.applyForm.querySelector("input[name=business-name]");
        var _province = form.querySelector("select[name=select-province]");
        var _bankRadio = form.querySelector("input[name=\"select-bank\"]:checked");
        var _otherBank = form.querySelector("input[name=other-bank]");
        var _popiConsent = this.applyForm.querySelector("input[name=popia-consent]");
        if (_contactNumber.value.length != 10) {
            errors.push('South African contact numbers are 10 digits');
        }
        if (!this.validSAContact(_contactNumber)) {
            errors.push('This contact number is invalid');
        }
        if (errors.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_contactNumber, errors);
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        var _postData = {
            subject: "Push'ispan",
            product: "Push'ispan",
            firstName: (_firstName ? _firstName.value : ""),
            surname: (_surname ? _surname.value : ""),
            emailAddress: (_email ? _email.value : ""),
            email: (_recipient ? _recipient.value : ""),
            recipient: (_mailBoxEmail ? _mailBoxEmail.value : ""),
            contactNo: (_contactNumber ? _contactNumber.value : ""),
            businessName: (_businessName ? _businessName.value : ""),
            province: (_province ? _province.value : ""),
            bank: (_bankRadio && _bankRadio.value === 'Yes' ? 'Standard Bank' : ''),
            otherBank: (_otherBank ? _otherBank.value : ""),
            dataPrivacyConsent: ((_popiConsent && _popiConsent.checked) ? "YES" : "NO"),
            dataSharingGroup: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-group'),
            dataSharing3rdParty: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-3rd-party'),
            dataSharingBoarders: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-boarders'),
            dataSharingTelesale: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-telesale'),
            dataSharingEmail: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-email'),
            dataSharingSms: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-sms'),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/push-ispan";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            var _response = response.data;
            if (_response.toString().includes('invalid')) {
                analyticsService.dtmFormComplete("complete", "false");
                _this.showDisplayView("fail");
            }
            else {
                if (_displayName) {
                    _displayName.map(function (pElement) {
                        pElement.innerHTML = _postData.firstname;
                    });
                }
                analyticsService.dtmFormComplete("complete", "true");
                _this.showDisplayView("success");
                window.scroll({ top: 0, behavior: "smooth" });
            }
        }).catch(function (response) {
            analyticsService.dtmFormComplete("complete", "false");
            this.showDisplayView("fail");
        });
    };
    return PushIspan;
}(Base));
export { PushIspan };



//////////////////
// WEBPACK FOOTER
// ./components/push-ispan/push-ispan.component.ts
// module id = 1125
// module chunks = 0